import Enums from '../helpers/Enums'
import ds from '../services/DataSourceService'

export const FilesGetMixin = {
  async created() {
    //this.logMessage()
  },
  data() {
    return {
      //message: 'Hello from FilesGetMixin',
    }
  },
  methods: {
    //logMessage() {
    //console.log(this.message)
    //},
    async getFile(media) {
      console.log('===========', media)
      let retVal = ''
      if (
        [
          Enums.MediaType.menu_item_image,
          Enums.MediaType.project_title_image,
          Enums.MediaType.poi_image,
          Enums.MediaType.poi_image_dzi
        ].includes(media.mediaTypeId)
      ) {
        let resp = await this.$store.dispatch('MediaStore/getFile', media)
        var mimeType = resp.headers['content-type'].toLowerCase()
        var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
        retVal = 'data:' + mimeType + ';base64,' + imgBase64
      } else {
        console.warn('Unknown media type, cannot get data')
      }
      return retVal

      // console.log('getFile')
      // let retVal = require('../assets/default_file_icon.png')
      // if (media.path !== '') {
      //   const resp = await ds
      //     .apiClientThinkHome({
      //       method: 'get',
      //       url: `/media/${media.id}/image`,
      //       responseType: 'arraybuffer'
      //     })
      //     .catch(e => {
      //       console.warn('Problems getting image', e)
      //     })
      //   console.log('resp', resp)
      //   if (resp) {
      //     var mimeType = resp.headers['content-type'].toLowerCase()
      //     var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
      //     retVal = 'data:' + mimeType + ';base64,' + imgBase64
      //   }
      // } else if (media.url !== '') {
      //   retVal = media.url
      // }
      // return retVal
    },
    async getUpload(tempFileName) {
      console.log('getUpload')
      let retVal = require('../assets/default_file_icon.png')

      const resp = await ds
        .apiClientThinkHome({
          method: 'get',
          url: `/media/upload/${tempFileName}`,
          responseType: 'arraybuffer'
        })
        .catch(e => {
          console.warn('Problems getting image', e)
        })
      console.log('resp', resp)
      if (resp) {
        var mimeType = resp.headers['content-type'].toLowerCase()
        var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
        retVal = 'data:' + mimeType + ';base64,' + imgBase64
      }

      return retVal
    }
  }
}
